import { styled } from 'linaria/react';
import { css } from 'linaria';

export const LinkWrapper = styled.a`
	display: flex;
	flex-direction: row;
	align-items: center;
	max-width: max-content;
	text-decoration: none;
	cursor: pointer;

	&:visited,
	&:link {
		& > span {
			color: var(--text-minor);
		}
	}

	@media (hover) {
		&:hover {
			& > span {
				color: var(--text-secondary);
			}

			& > div > svg {
				fill: var(--text-secondary);
			}
		}
	}
`;

export const text = css`
	padding-left: 4px;
	color: var(--text-minor);
`;
